import { render, staticRenderFns } from "./returnDetails.vue?vue&type=template&id=1b9974e1&scoped=true"
import script from "./returnDetails.vue?vue&type=script&lang=js"
export * from "./returnDetails.vue?vue&type=script&lang=js"
import style0 from "./returnDetails.vue?vue&type=style&index=0&id=1b9974e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9974e1",
  null
  
)

export default component.exports